import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-300 dark:text-gray-500" }, ".", -1)
const _hoisted_3 = { class: "mr-px text-gray-300 dark:text-gray-500" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-300 dark:text-gray-500" }, ".", -1)

import { computed } from 'vue';

import useUserSettings from '@/composables/useUserSettings';
import { FiatSymbol } from '@/constants/currency';

import BalLoadingBlock from '../BalLoadingBlock/BalLoadingBlock.vue';

/**
 * TYPES
 */
type NumberType = 'token' | 'fiat';

type Props = {
  type: NumberType;
  numberWidth: string;
  numberHeight: string;
};

/**
 * PROPS & EMITS
 */

export default /*#__PURE__*/_defineComponent({
  props: {
    type: { default: 'token' },
    numberWidth: { default: '3' },
    numberHeight: { default: '5' }
  },
  setup(__props: any) {

const props = __props as { type: NumberType, numberWidth: string, numberHeight: string }



/**
 * COMPOSABLES
 */
const { currency } = useUserSettings();

/**
 * COMPUTED
 */
const currencySymbol = computed(() => FiatSymbol[currency.value]);

const blockClasses = computed(() => [
  `w-${props.numberWidth}`,
  `h-${props.numberHeight}`,
  'mr-px',
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.type === 'token')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(BalLoadingBlock, {
            class: _normalizeClass(_unref(blockClasses)),
            rounded: "sm",
            darker: ""
          }, null, 8, ["class"]),
          _createVNode(BalLoadingBlock, {
            class: _normalizeClass(_unref(blockClasses)),
            rounded: "sm",
            darker: ""
          }, null, 8, ["class"]),
          _hoisted_2,
          _createVNode(BalLoadingBlock, {
            class: _normalizeClass(_unref(blockClasses)),
            rounded: "sm",
            darker: ""
          }, null, 8, ["class"]),
          _createVNode(BalLoadingBlock, {
            class: _normalizeClass(_unref(blockClasses)),
            rounded: "sm",
            darker: ""
          }, null, 8, ["class"]),
          _createVNode(BalLoadingBlock, {
            class: _normalizeClass(_unref(blockClasses)),
            rounded: "sm",
            darker: ""
          }, null, 8, ["class"]),
          _createVNode(BalLoadingBlock, {
            class: _normalizeClass(_unref(blockClasses)),
            rounded: "sm",
            darker: ""
          }, null, 8, ["class"])
        ], 64))
      : (__props.type === 'fiat')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(currencySymbol)), 1),
            _createVNode(BalLoadingBlock, {
              class: _normalizeClass(_unref(blockClasses)),
              rounded: "sm",
              darker: ""
            }, null, 8, ["class"]),
            _createVNode(BalLoadingBlock, {
              class: _normalizeClass(_unref(blockClasses)),
              rounded: "sm",
              darker: ""
            }, null, 8, ["class"]),
            _hoisted_4,
            _createVNode(BalLoadingBlock, {
              class: _normalizeClass(_unref(blockClasses)),
              rounded: "sm",
              darker: ""
            }, null, 8, ["class"]),
            _createVNode(BalLoadingBlock, {
              class: _normalizeClass(_unref(blockClasses)),
              rounded: "sm",
              darker: ""
            }, null, 8, ["class"])
          ], 64))
        : _createCommentVNode("", true)
  ]))
}
}

})